'use client';

import React, { useState, useCallback, useMemo } from 'react';
import { cn } from '@/lib/utils';

type DescriptionProps = {
  description: string;
  className?: string;
};

export default function Description({
  description,
  className,
}: DescriptionProps) {
  const [expanded, setExpanded] = useState(false);

  const paragraphs = useMemo(
    () =>
      description.split('\n').filter((paragraph) => paragraph.trim() !== ''),
    [description],
  );

  const handleToggleExpand = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  const buttonText = expanded ? 'Collapse' : 'Read more';

  return (
    <div className="mt-6">
      <div
        className={cn(
          'prose prose-sm max-w-none',
          !expanded && 'line-clamp-6',
          className,
        )}
      >
        {paragraphs.map((paragraph, index) => (
          // eslint-disable-next-line react/no-array-index-key -- We're not iterating over dynamic data
          <p className={index === 0 ? 'text-lg' : ''} key={index}>
            {paragraph}
          </p>
        ))}
      </div>
      {paragraphs.length > 1 && (
        <button
          className="mt-2 text-sm font-semibold text-gray-900 transition-colors hover:text-gray-700"
          onClick={handleToggleExpand}
          type="button"
        >
          {buttonText}
        </button>
      )}
    </div>
  );
}
